import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppAskDirectout from "./AppAskDirectout";
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import { getConfig } from "./config";
import { Auth0Provider } from "@auth0/auth0-react";
import store from './state/store';
import {ThemeProvider} from "./components/content/ThemeManager";

const config = getConfig();

const providerConfig = {
    domain: config.domain,
    clientId: config.clientId,
    authorizationParams: {
        redirect_uri: window.location.origin,
        ...(config.audience ? { audience: config.audience } : null),
    },
    cacheLocation: config.cacheLocation,
};


const AppProvider = () => {
    switch (process.env.REACT_APP_CONFIG) {
        case 'ask_directout': return <AppAskDirectout />;
        default: return <App />;
    }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Auth0Provider {...providerConfig}>
            <Provider store={store}>
                <ThemeProvider />
                <AppProvider />
            </Provider>
        </Auth0Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
